<template>
  <div class="column is-12 tab-content">
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div class="columns">
      <div
        v-if="show"
        class="column is-6 news-content"
      >
        <div class="card box news-box">
          <div class="card-image">
            <figure class="image is-16by9">
              <img
                v-if="firstNews.headerimage"
                :src="firstNews.largepreviewimage"
              >
              <img
                v-if="!firstNews.headerimage"
                src="/images/img_default.jpg"
              >
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-5">
                  {{ firstNews.title }}
                </p>
              </div>
            </div>
            <div class="card-content">
              <p>{{ stripeTags(firstNews.previewtext, 200) }}</p>
            </div>
            <router-link
              :to="{name: 'News-details', params: {id: firstNews.id, title: firstNews.title.toString().replace(/\?/g,'').toLowerCase().split(' ').join('-'), news: firstNews}}"
              class="button is-small link-right"
            >
              <i class="far fa-arrow-right" />
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-if="show"
        class="column news news-content"
      >
        <div
          v-for="news in lastThreeNews"
          class="box"
        >
          <article class="media">
            <div class="media-left">
              <img
                v-if="news.headerimage"
                :src="news.smallpreviewimage"
              >
              <img
                v-if="!news.headerimage"
                src="/images/img_default.jpg"
              >
            </div>
            <div class="media-content">
              <div class="content">
                <strong>{{ news.title }}</strong>
                <p v-html="stripeTags(news.previewtext, 100)" />
              </div>
              <router-link
                :to="{name: 'News-details', params: {id: news.id, title: news.title.toString().replace(/\?/g,'').toLowerCase().split(' ').join('-'), news: news}}"
                class="button is-small link-right"
              >
                <i class="far fa-arrow-right" />
              </router-link>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'NewsBlock',
    components: {
    },
    props: ['user', 'token'],
    data() {
      return {
        news: [],
        show: false
      }
    },
    computed: {
      firstNews() {
        return this.news && this.news.length > 0 ? this.news[0] : null
      },
      lastThreeNews() {
        return this.news.slice(1, 4)
      }
    },
    created() {
      this.$axios({
        method: 'POST',
        url: 'general',
        data: {
          token: this.token || ''
        }
      })
        .then((res) => {
          this.show = true
          this.news = res.data.news
        })
        .catch((error) => {
          this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
        })
    },
    methods: {
      stripeTags(string, length) {
        if (string) {
          return string.replace(/(<([^>]+)>)/ig, '').substring(0, length)
        }
      }
    }
  }
</script>
